// graphql/oattRates.gql.ts
import { gql } from '@apollo/client';

export const GET_OATT_RATES = gql`
  query GetOattRates($type: String, $service_type: String) {
    oattRates(type: $type, service_type: $service_type) {
      oatt_rate_id
      type
      service_type
      transmission_service_type
      transmission_details
      ancillary_service_type
      ancillary_service_details
      frequency
      rate
      comments
      updated_at
    }
  }
`;

export const UPDATE_OATT_RATES = gql`
  mutation UpdateOattRates($updates: [UpdateOattRateInput!]!) {
    updateOattRates(updates: $updates) {
      success
      updatedCount
      message
    }
  }
`;